wbApp.controller('LeadsCtrl', ['$scope', '$modal', '$translate', '$filter', '$timeout', 'leadSvc', 'localStorageService', 
    'semesterSvc', 'securitySvc', 'gridSortSvc', 'levelSvc', 'phaseSvc', 'contractSvc',
function ($scope, $modal, $translate, $filter, $timeout, leadSvc, localStorageService, 
          semesterSvc, securitySvc, gridSortSvc, levelSvc, phaseSvc, contractSvc) {

    $scope.semesterDataRange = 2; // 1 - semester, 2 - from to
    $scope.fromDate = moment().subtract(3, 'M').startOf('day').toDate();
    $scope.toDate = moment().startOf('day').toDate();
    $scope.status = 0;

    semesterSvc.getDefaultAsync().then(function (data) {        
        if (!!data) {
            $scope.semesterID = data.id;
            if ($scope.semesterDataRange === 1) {
                refreshData();
            }
        }
    });

    if (localStorageService.isSupported) {
        $scope.semesterDataRange = localStorageService.get('semesterDataRange') || 2;
        $scope.status = localStorageService.get('leadStatus') || 0;
    }

    $scope.leads = [];

    function refreshData()
    {
        var selectedRowKeys = null;
        if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
            selectedRowKeys = $scope.gridSettings.gridInstance.getSelectedRowKeys();
        }

        // status, fromDateUtc, toDateUtc
        if ($scope.semesterDataRange === 2) {
            $scope.leads = leadSvc.getAllByStatusAndDateRange($scope.status, $scope.fromDate, $scope.toDate);
            $scope.leads.$promise.then(function () {

                if (!!selectedRowKeys && !!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                    $timeout(function () {
                        $scope.gridSettings.gridInstance.selectRows(selectedRowKeys, false).then(function (rows) {
                            if (!rows || !rows.length) {
                                setSelectedLead(null);
                            }
                        })
                    }, 100);                    
                }
                else {
                    setSelectedLead(null);
                }
            },
            function (error) {
                setSelectedLead(null);
            })
            
        } else if ($scope.semesterDataRange === 1 && $scope.semesterID) {
            $scope.leads = leadSvc.getAllByStatusAndSemester($scope.status, $scope.semesterID);
            setSelectedLead(null);
        }        
    }

    function setSelectedLead(lead) {
        $scope.selectedLead = lead;
        $scope.$broadcast('leadSelectionChanged', $scope.selectedLead);
    }

    refreshData();

    var semestersDataSource = new DevExpress.data.CustomStore({
        load: function (loadOptions) {
            return semesterSvc.getAllAsync().$promise;
        },
        byKey: function (e) {
            return semesterSvc.getAsync(e);
        },
        loadMode: 'processed'
    });
    
    var phaseDataSource = new DevExpress.data.CustomStore({
        load: function (loadOptions) {
            return phaseSvc.getAll().$promise;
        },
        byKey: function (e) {
            return phaseSvc.getById(e);
        },
        loadMode: 'processed'
    });

    $scope.gridSettings = {
        name: 'leads',
        keyExpr: 'id',
        shouldShowColumnChooser: true,
        columns: [
            {
                dataField: 'id',
                caption: $translate.instant('TXT_LBL_ID'),
                dataType: 'string',
                visible: false,
                showInColumnChooser: false
            },
            {
                showInColumnChooser: false,
                caption: '',
                dataField: 'marker',                
                width: '42px',
                alignment: 'center',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            loadMode: 'raw',
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_FLAG_RED') },
                                { id: 1, name: $translate.instant('TXT_FLAG_ORANGE') },
                                { id: 2, name: $translate.instant('TXT_FLAG_YELLOW') },
                                { id: 3, name: $translate.instant('TXT_FLAG_GREEN') },
                                { id: 4, name: $translate.instant('TXT_FLAG_BLUE') },
                                { id: 5, name: $translate.instant('TXT_FLAG_PURPLE') },
                                { id: 6, name: $translate.instant('TXT_FLAG_GRAY') },
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                encodeHtml: false,
                calculateSortValue: function(rowData) { return rowData.marker; },
                calculateDisplayValue: function (rowData) {
                    if (typeof rowData.marker === 'undefined' || rowData.marker === null) {
                        return "";
                    } else {
                        return "<i class='fa fa-flag' style='color:" + leadSvc.markerIdToColor(rowData.marker) + "' aria-hidden='true'></i>";
                    }
                },
            },
            {
                showInColumnChooser: false,
                caption: '',
                dataField: 'isNotRegisteredUser',
                width: '42px',
                alignment: 'center',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: true, name: $translate.instant('TXT_ANONYMOUS_USER') },
                                { id: false, name: $translate.instant('TXT_REGISTERED_USER') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                encodeHtml: false,
                calculateSortValue: function (rowData) { return rowData.marker; },
                calculateDisplayValue: function (rowData) {
                    if (typeof rowData.isNotRegisteredUser === 'undefined' || rowData.isNotRegisteredUser === null) {
                        return "";
                    } else {
                        var icon = !!rowData.isNotRegisteredUser ? 'fa-user-o' : 'fa-user';
                        var res = "<i class='fa " + icon + "' aria-hidden='true'></i>";

                        return res;
                    }
                },
            },
            { dataField: 'leadSourceReferenceId', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false, showInColumnChooser: false },
            {
                dataField: 'referenceNumber',
                name: 'referenceNumber',
                caption: $translate.instant('TXT_REFERENCE_NUMBER'),
                dataType: 'string',
                width: '50px',
                visible: false
            },
            {
                dataField: 'studentsFullName',
                caption: $translate.instant('TXT_LBL_STUDENT'),
                dataType: 'string',
                width: '140px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentsFullName') }
            },
          
            {
                dataField: 'phaseId',
                caption: $translate.instant('TXT_PHASE'),
                dataType: 'string',
                width: '140px',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: phaseDataSource,
                        pageSize: 20,
                        paginate: true
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                }
            },
            {
                dataField: 'levelId',
                caption: $translate.instant('TXT_LEVEL'),
                dataType: 'string',
                width: '100px',
                calculateCellValue: function (rowData) {
                    return $filter('level')(rowData.levelId);
                }
            },
            {
                dataField: 'semesterId',
                caption: $translate.instant('TXT_LBL_SEMESTER'),
                dataType: 'string',
                width: '150px',
                visible: false,
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: semestersDataSource,
                        pageSize: 20,
                        paginate: true
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
            },
            { dataField: 'studentBirthday', caption: $translate.instant("TXT_LBL_BIRTHDAY"), dataType: 'date', format: { date: 'short' }, width: '70px' },
            { 
                dataField: 'studentBirthday', 
                caption: $translate.instant("TXT_LBL_AGE"), 
                dataType: 'string',
                visible: false,
                calculateCellValue: function (rowData) {
                    return rowData.studentBirthday 
                        ? moment(rowData.studentBirthday).toNow(true) 
                        : '';
                },
                width: '70px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '130px'
            },
            {
                dataField: 'email',
                caption: $translate.instant('TXT_LBL_EMAIL'),
                dataType: 'string',
                visible: false,
                width: '190px'
            },
            {
                dataField: 'leadSourceType',
                caption: $translate.instant('TXT_CONSENT_TYPE'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_LEAD_SOURCE_FORM_RESPONSE') },
                                { id: 1, name: $translate.instant('TXT_LEAD_SOURCE_FULL_COURSE_INTEREST') },
                                { id: 2, name: $translate.instant('TXT_LEAD_SOURCE_PHONE') },
                                { id: 3, name: $translate.instant('TXT_LEAD_SOURCE_EMAIL') },
                                { id: 4, name: $translate.instant('TXT_LEAD_SOURCE_PERSONAL_CONTACT') },
                                { id: 5, name: $translate.instant('TXT_LEAD_SOURCE_COURSE_INTEREST') },
                                { id: 6, name: $translate.instant('TXT_LEAD_SOURCE_FORM_RESPONSE_KINDERGARTEN_ENROLLMENT') },
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                width: '70px'
            },
            {
                dataField: 'userFullName',
                caption: $translate.instant('TXT_VAL_RCPG_USER'),
                width: '140px',
                dataType: 'string',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'userFullName') }
            },
            {
                dataField: 'leadSourceName',
                caption: $translate.instant('TXT_NAME'),
                dataType: 'string',
                width: '120px'
            },
            {
                dataField: 'leadSourceText',
                caption: $translate.instant('TXT_LBL_TEXT'),
                dataType: 'string',
                width: '160px'
            },
            {
                dataField: 'lastNoteText',
                caption: $translate.instant('TXT_LBL_NOTE'),
                dataType: 'string'
            },
            { dataField: 'createdAtUtc', caption: $translate.instant('TXT_LBL_CREATED_AT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px' },
            { dataField: 'nextContactAtUtc', caption: $translate.instant('TXT_LBL_NEXT_CONTACT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px' },
            { dataField: 'decisionDateUtc', caption: $translate.instant('TXT_LBL_LAST_ACTIVITY'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px', sortOrder: 'desc' },
        ],
        onEditorPreparing: function(e) {  
            if (e.parentType == 'filterRow' && e.dataField == 'marker') {
                e.editorOptions.itemTemplate = function (itemData, itemIndex, itemElement) {
                    if (itemIndex == 0) {
                        return $("<i class='fa fa-flag-o' aria-hidden='true'></i>");
                    } else {
                        return $("<i class='fa fa-flag' style='color:" + leadSvc.markerIdToColor(itemData.id) + "' aria-hidden='true'></i>");
                    }
                }
            }
            else {
                if (e.parentType == 'filterRow' && e.dataField == 'isNotRegisteredUser') {
                    e.editorOptions.itemTemplate = function (itemData, itemIndex, itemElement) {
                        if (itemIndex == 0) {
                            return $("<i class='fa fa-user-circle' aria-hidden='true'></i>");
                        } else {
                            var icon = itemIndex == 1 ? 'fa-user-o' : 'fa-user';
                            var res = "<i class='fa " + icon + "' aria-hidden='true'></i>";

                            return res;
                        }
                    }
                }
                else {
                    if (e.parentType == 'filterRow' && e.dataField == 'levelId') {
                        e.editorName = "dxTextBox";
                    }
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_SHOW_PREVIEW'),
            isVisible: function (data) { return (data.leadSourceType == 0 || data.leadSourceType == 6) && securitySvc.isInRole('FormsDefinitions'); },
            callback: function (data) { $scope.onShowFormPreview(data.leadSourceReferenceId); }
        }, {
            text: $translate.instant('TXT_CHANGE_STATE'),
            isVisible: function (data) { return !!data && data.status != 1 && securitySvc.isInRole('FormsResponse.Update'); },
            callback: function (data) { $scope.onChangeStatus(data); }
        }, {
            text: $translate.instant('TXT_MENU_REGISTER_ON_COURSE'),
            isVisible: function (data) {
                return !!data &&
                    data.leadSourceType != 6 &&
                    data.status != 1 &&
                    !data.isNotRegisteredUser &&
                    securitySvc.isInRole('FormsResponse.Update') &&
                    securitySvc.isInRole('CourseRegistration.Insert');
            },
            callback: function (data) { $scope.onAssignCourse(data); }
        }, {
            text: $translate.instant('TXT_MENU_CREATE_CONTRACT'),
            isVisible: function (data) {
                return !!data &&
                    data.leadSourceType == 6 &&
                    data.status != 1 &&
                    !data.isNotRegisteredUser &&
                    securitySvc.isInRole('Leads.Update') &&
                    securitySvc.isInRole('Contract.Insert');
            },
            callback: function (data) { $scope.onCreateContract(data); }
        }, {
            text: $translate.instant('TXT_SEND_ADMISSION_ACCEPTANCE'),
            isVisible: function (data) { return !!data && data.leadSourceType == 6 && securitySvc.isInRole('Leads.Update'); },
            callback: function (data) { $scope.onSendAdmissionAcceptance(data); },
            beginGroup: true
        },{
            text: $translate.instant('TXT_PRINT_ADMISSION_ACCEPTANCE'),
            isVisible: function (data) { return !!data && data.leadSourceType == 6 && securitySvc.isInRole('Leads.Update'); },
            callback: function (data) { $scope.onPrintAdmissionAcceptance(data); }
        }, {
            text: $translate.instant('TXT_SEND_ADMISSION_REJECTION'),
            isVisible: function (data) { return !!data && data.leadSourceType == 6 && securitySvc.isInRole('Leads.Update'); },
            callback: function (data) { $scope.onSendAdmissionRejection(data); },
            beginGroup: true
        }, {
            text: $translate.instant('TXT_PRINT_ADMISSION_REJECTION'),
            isVisible: function (data) { return !!data && data.leadSourceType == 6 && securitySvc.isInRole('Leads.Update'); },
            callback: function (data) { $scope.onPrintAdmissionRejection(data); }
        }]
    }
    
    $scope.onSendAdmissionAcceptance = function(lead) {
        leadsAdmissionDialogPromise.$promise.then(function () {
            leadsAdmissionDialogPromise.$scope.lead = lead;
            leadsAdmissionDialogPromise.$scope.dialogType = 'sendAdmissionAcceptance';
            leadsAdmissionDialogPromise.onSaveChanges = function () {
                refreshData();
            };
            leadsAdmissionDialogPromise.show();
        });
    }

    $scope.onSendAdmissionRejection = function(lead) {
        leadsAdmissionDialogPromise.$promise.then(function () {
            leadsAdmissionDialogPromise.$scope.lead = lead;
            leadsAdmissionDialogPromise.$scope.dialogType = 'sendAdmissionRejection';
            leadsAdmissionDialogPromise.onSaveChanges = function () {
                refreshData();
            };
            leadsAdmissionDialogPromise.show();
        });
    }

    $scope.onPrintAdmissionAcceptance = function(lead) {
        leadsAdmissionDialogPromise.$promise.then(function () {
            leadsAdmissionDialogPromise.$scope.lead = lead;
            leadsAdmissionDialogPromise.$scope.dialogType = 'printAdmissionAcceptance';
            leadsAdmissionDialogPromise.onSaveChanges = function () {
                refreshData();
            };
            leadsAdmissionDialogPromise.show();
        });
    }

    $scope.onPrintAdmissionRejection = function(lead) {
        leadsAdmissionDialogPromise.$promise.then(function () {
            leadsAdmissionDialogPromise.$scope.lead = lead;
            leadsAdmissionDialogPromise.$scope.dialogType = 'printAdmissionRejection';
            leadsAdmissionDialogPromise.onSaveChanges = function () {
                refreshData();
            };
            leadsAdmissionDialogPromise.show();
        });
    }    

    
    $scope.onShowFormPreview = function (formResponseId) {
        formPreviewPromise.$promise.then(function () {
            formPreviewPromise.$scope.formId = null;
            formPreviewPromise.$scope.formDefinitionRevision = null;
            formPreviewPromise.$scope.formResponseId = formResponseId;
            formPreviewPromise.show();
        });
    }


    $scope.$on('refreshData', function (e, data) {
        refreshData();
    });

    $scope.$on('leadChanged', function (e, data) {
        refreshData();
    });

    $scope.onRowSelected = function (data) {
        setSelectedLead(data);
    }

    $scope.onRowAdd = function () {
        leadsDetailPromise.$promise.then(function () {
            leadsDetailPromise.$scope.model = leadSvc.createNew();
            leadsDetailPromise.$scope.onLeadSave = function (model) {
                refreshData();
            };
            leadsDetailPromise.show();
        });
    }

    $scope.onRowEdit = function (lead) {
        leadsDetailPromise.$promise.then(function () {
            leadsDetailPromise.$scope.leadId = lead.id;
            leadsDetailPromise.$scope.model = null;
            leadsDetailPromise.$scope.onLeadSave = function () {
                refreshData();
            };
            leadsDetailPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        leadSvc.remove(data.id).$promise.then(function () {
            refreshData();
        });
    }

    $scope.onDataRangeChanged = function () {
        if (!!$scope.fromDate && moment($scope.fromDate).isValid() && !!$scope.toDate && moment($scope.toDate).isValid()) {
            if (localStorageService.isSupported) {
                localStorageService.set('semesterDataRange', $scope.semesterDataRange);
            }
            refreshData();
        }
    }

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            // get invoices
            refreshData();            
        }
    }

    $scope.onChangeStatus = function (lead) {
        leadsNoteDetailPromise.$promise.then(function () {
            leadsNoteDetailPromise.$scope.leadId = lead.id;
            leadsNoteDetailPromise.$scope.noteId = null;
            leadsNoteDetailPromise.$scope.onLeadSave = function (model) {
                refreshData();
            };
            leadsNoteDetailPromise.show();
        });
    }

    $scope.onLeadStatusChange = function (status) {
        if (localStorageService.isSupported) {
            localStorageService.set('leadStatus', status);
        }
        refreshData();
    }

    $scope.onAssignCourse = function (lead) {
        leadsAssingCourseDetailPromise.$promise.then(function () {
            leadsAssingCourseDetailPromise.$scope.leadSourceType = lead.leadSourceType;
            leadsAssingCourseDetailPromise.$scope.leadSourceReferenceId = lead.leadSourceReferenceId;
            leadsAssingCourseDetailPromise.$scope.leadId = lead.id;
            leadsAssingCourseDetailPromise.$scope.studentId = lead.studentIds[0];
            leadsAssingCourseDetailPromise.$scope.onLeadSave = function (model) {
                refreshData();
            };
            leadsAssingCourseDetailPromise.show();
        });
    }

    $scope.onCreateContract = function (lead) {
        contractDetailDialogPromise.$promise.then(function () {
            contractSvc.createNew().then(function(newModel) {
                
                newModel.userId = lead.userId;
                newModel.studentId = lead.studentIds[0];
                
                contractDetailDialogPromise.$scope.model = newModel;
                contractDetailDialogPromise.$scope.disableUserStudentSelection = true;
                contractDetailDialogPromise.$scope.onContractSave = function (model) {

                    leadSvc.getById(lead.id).$promise.then(function (freshLead) {
                        freshLead.conversionType = 2; // Contract
                        freshLead.conversionReferenceId = model.id;
                        freshLead.conversionDateUtc = moment().toDate();

                        
                        if (moment(model.toDate).isValid()) {
                            freshLead.conversionText = $translate.instant('TXT_MENU_CONTRACT_CREATED').f($filter('date')(model.fromDate, 'dd.MM.yy'), $filter('date')(model.toDate, 'dd.MM.yy'));
                        } else {
                            freshLead.conversionText = $translate.instant('TXT_MENU_CONTRACT_CREATED').f($filter('date')(model.fromDate, 'dd.MM.yy'), "");
                        }
                        
                        freshLead.status = 1; // Converted
                        if (!freshLead.notes || freshLead.notes.length == 0) {
                            freshLead.notes = [];
                        }

                        let user = securitySvc.loggedInUser();
                        freshLead.notes.push({
                            text: freshLead.conversionText,
                            updatedAtUtc: moment().toDate(),
                            updatedByUserId: user.userID + "",
                            updatedByName: user.fullName
                        });

                        leadSvc.update(freshLead).$promise.then(function () {
                            refreshData();
                        });                        
                    });
                };                 
                contractDetailDialogPromise.show();
            });
        });
    }
    
    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "leads/leads-detail-tabs/detail.html"
    }, {
        title: 'TXT_LBL_COURSES',
        template: "leads/leads-detail-tabs/user-history-courses.html"
    }, {
        title: 'TXT_LBL_ACTIONS',
        template: "leads/leads-detail-tabs/user-history-actions.html"
    }, {
        title: 'TXT_LBL_NOTES',
        template: "leads/leads-detail-tabs/crm-notes.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });


    var formPreviewPromise = $modal({
        templateUrl: 'forms/forms-response-preview.html',
        show: false,
        scope: $scope.$new()
    });

    var leadsNoteDetailPromise = $modal({
        templateUrl: 'leads/leads-detail-tabs/crm-notes-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var leadsAssingCourseDetailPromise = $modal({
        templateUrl: 'leads/leads/leads-assing-course-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var leadsDetailPromise = $modal({
        templateUrl: 'leads/leads-detail.html',
        show: false,
        scope: $scope.$new()
    });
    
    var leadsAdmissionDialogPromise = $modal({
        templateUrl: 'leads/leads/leads-admission-dialog.html',
        show: false,
        scope: $scope.$new()
    });

    var contractDetailDialogPromise = $modal({
        templateUrl: 'activities/contracts/contract-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
